export default {
	propose:
		'Sukurkite savo renginį ir parduokite\nbilietus internetu naudodamiesi satchel.events paslaugomis!',
	description: 'Nepakartojama patirtis\nprasideda nuo bilieto įsigijimo!',
	moreEvents: 'Rodyti daugiau įvykių',
	search: 'Paieška'
}
